import Vue from 'vue';
import Router from 'vue-router';
import PageAuthorization from './modules/Auth/pages/PageAuthorization.vue';
import PageProfile from './modules/Profile/pages/PageProfile.vue';
import PageConfirmEmail from './modules/Auth/pages/PageConfirmEmail.vue';
import PageNotFound from './views/PageNotFound.vue';
import PageRegistration from './modules/Auth/pages/PageRegistration.vue';
import PageCarList from "@/modules/CarList/views/PageCarList.vue";
import {IApp} from "@/interfaces/app.interface";
import PageBarriers from "@/modules/barriers/pages/PageBarriers.vue";
import PageParkingAccess from "@/modules/ParkingAccess/pages/PageParkingAccess.vue";
import Report from "@/modules/Report/pages/PageReport.vue";
import DashboardPage from "@/modules/Dashboard/pages/DashboardPage.vue";
import {IReport} from "@/modules/Report/interfaces/report.interface";
import ROUTE_NAME = IApp.ROUTE_NAME;
import PageHome from "@/modules/Home/pages/PageHome.vue";
import PageSupport from "@/modules/Support/pages/PageSupport.vue";
import PageScreenPay from "@/modules/ScreenPay/pages/PageScreenPay.vue";
import PageParksConfig from "@/modules/ParksConfig/pages/PageParksConfig.vue";
import PageDeviceStats from "@/modules/DeviceStats/pages/PageDeviceStats.vue";
import PageCorps from "@/modules/Corps/pages/PageCorps.vue";
import PageFindDriver from "@/modules/FindDriver/pages/PageFindDriver.vue";
import PagePaymentResult from "@/modules/Payment/pages/PagePaymentResult.vue";

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.VUE_APP_PUBLIC_URL,
  routes: [
    { path: '*', redirect: '/404', },
    { path: IApp.RoutePath[ROUTE_NAME.HOME],                            name: ROUTE_NAME.HOME,                      component: PageHome, },
    { path: IApp.RoutePath[ROUTE_NAME.PAGE_SCREEN_PAY],                 name: ROUTE_NAME.PAGE_SCREEN_PAY,           component: PageScreenPay, },
    { path: IApp.RoutePath[ROUTE_NAME.PAGE_AUTHORIZATION],              name: ROUTE_NAME.PAGE_AUTHORIZATION,        component: PageAuthorization, },
    { path: IApp.RoutePath[ROUTE_NAME.PAGE_PROFILE],                    name: ROUTE_NAME.PAGE_PROFILE,              component: PageProfile, },
    { path: IApp.RoutePath[ROUTE_NAME.PAGE_CONFIRM_EMAIL],              name: ROUTE_NAME.PAGE_CONFIRM_EMAIL,        component: PageConfirmEmail, },
    { path: IApp.RoutePath[ROUTE_NAME.PAGE_404],                        name: ROUTE_NAME.PAGE_404,                  component: PageNotFound, },
    { path: IApp.RoutePath[IApp.ROUTE_NAME.PAGE_REGISTRATION],          name: ROUTE_NAME.PAGE_REGISTRATION,         component: PageRegistration, },
    { path: IApp.RoutePath[ROUTE_NAME.PAGE_CAR_LIST],                   name: ROUTE_NAME.PAGE_CAR_LIST,             component: PageCarList, },
    { path: IApp.RoutePath[ROUTE_NAME.PAGE_BARRIERS],                   name: ROUTE_NAME.PAGE_BARRIERS,             component: PageBarriers, },
    { path: IApp.RoutePath[ROUTE_NAME.PAGE_PARKING_ACCESS],             name: ROUTE_NAME.PAGE_PARKING_ACCESS,       component: PageParkingAccess, },
    { path: IApp.RoutePath[ROUTE_NAME.PAGE_DASHBOARD],                  name: ROUTE_NAME.PAGE_DASHBOARD,            component: DashboardPage, },
    { path: IApp.RoutePath[ROUTE_NAME.PAGE_SUPPORT],                    name: ROUTE_NAME.PAGE_SUPPORT,              component: PageSupport, },
    { path: IApp.RoutePath[ROUTE_NAME.PAGE_PARKS_CONFIG],               name: ROUTE_NAME.PAGE_PARKS_CONFIG,         component: PageParksConfig, },
    { path: IApp.RoutePath[ROUTE_NAME.PAGE_DEVICE_STATS],               name: ROUTE_NAME.PAGE_DEVICE_STATS,         component: PageDeviceStats, },
    { path: IApp.RoutePath[ROUTE_NAME.PAGE_CORPS],                      name: ROUTE_NAME.PAGE_CORPS,                component: PageCorps, },
    { path: IApp.RoutePath[ROUTE_NAME.PAGE_FIND_DRIVER],                name: ROUTE_NAME.PAGE_FIND_DRIVER,          component: PageFindDriver, },
    { path: IApp.RoutePath[ROUTE_NAME.PAGE_PAYMENT_RESULT],             name: ROUTE_NAME.PAGE_PAYMENT_RESULT,       component: PagePaymentResult, },
    {
      path: IApp.RoutePath[ROUTE_NAME.PAGE_REPORT],
      name: ROUTE_NAME.PAGE_REPORT,
      component: Report,
      children: [
        {
          path: IApp.RoutePath[ROUTE_NAME.PAGE_REPORT_MOVEMENTS],
          component: Report,
          name: ROUTE_NAME.PAGE_REPORT_MOVEMENTS,
          meta: { command: IReport.ReportName.Movement },
        },
        {
          path: IApp.RoutePath[ROUTE_NAME.PAGE_REPORT_BALANCE],
          component: Report,
          name: ROUTE_NAME.PAGE_REPORT_BALANCE,
          meta: { command: IReport.ReportName.Balance },
        },
        {
          path: IApp.RoutePath[ROUTE_NAME.PAGE_REPORT_EVENTS],
          component: Report,
          name: ROUTE_NAME.PAGE_REPORT_EVENTS,
          meta: { command: IReport.ReportName.Events },
        },
        {
          path: IApp.RoutePath[ROUTE_NAME.PAGE_REPORT_CARS],
          component: Report,
          name: ROUTE_NAME.PAGE_REPORT_CARS,
          meta: { command: IReport.ReportName.Cars },
        },
        {
          path: IApp.RoutePath[ROUTE_NAME.PAGE_REPORT_CARS_BALANCE],
          component: Report,
          name: ROUTE_NAME.PAGE_REPORT_CARS_BALANCE,
          meta: { command: IReport.ReportName.CarsBalance },
        },
        {
          path: IApp.RoutePath[ROUTE_NAME.PAGE_REPORT_PARKS],
          component: Report,
          name: ROUTE_NAME.PAGE_REPORT_PARKS,
          meta: { command: IReport.ReportName.Parks },
        },
        {
          path: IApp.RoutePath[ROUTE_NAME.PAGE_REPORT_AGENT],
          component: Report,
          name: ROUTE_NAME.PAGE_REPORT_AGENT,
          meta: { command: IReport.ReportName.Agent },
        },
      ],
    },
  ],
});
